function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import { PRODUCT_ADD_BUTTON_TEST_ID } from "../constants";
import Cart from "../../Icon/Cart";
import Icon from "../../Icon/Icon";
import Button from "../../Button";
import { EnumButtonSize } from "../types";
import colors from "../../../colors";
export var ButtonStyled = styled(Button).withConfig({
  displayName: "OrderControls__ButtonStyled",
  componentId: "sc-1wka1n0-0"
})(["flex-shrink:0;", ";"], function (_ref) {
  var isKomus = _ref.isKomus;

  if (isKomus) {
    return css(["line-height:16px !important;font-size:14px !important;font-weight:normal;background-color:", ";color:", " !important;&:hover,&:active,&:focus{background-color:", ";color:", " !important;border:1px solid ", ";}"], colors.light200, colors.primaryMain, colors.light200, colors.primaryMain, colors.primaryMain);
  }
});
export var OrderButton = styled(ButtonStyled).attrs(function (_ref2) {
  var theme = _ref2.theme,
      isKomus = _ref2.isKomus;
  return {
    theme: _objectSpread({}, theme, {
      button: isKomus ? _objectSpread({}, theme.button, {}, theme.basketKomus.button) : _objectSpread({}, theme.button, {}, theme.order.button)
    })
  };
}).withConfig({
  displayName: "OrderControls__OrderButton",
  componentId: "sc-1wka1n0-1"
})(["flex-grow:1;"]);
var MobileButton = styled(ButtonStyled).attrs(function (_ref3) {
  var theme = _ref3.theme,
      isKomus = _ref3.isKomus;
  return {
    theme: _objectSpread({}, theme, {
      button: isKomus ? _objectSpread({}, theme.button, {}, theme.basketKomus.button) : _objectSpread({}, theme.button, {}, theme.basket.button)
    })
  };
}).withConfig({
  displayName: "OrderControls__MobileButton",
  componentId: "sc-1wka1n0-2"
})([""]); // элементу Flex нельзя прокинуть ref, поэтому здесь заговнокожено

var OrderControlsWrapper = styled.div.withConfig({
  displayName: "OrderControls__OrderControlsWrapper",
  componentId: "sc-1wka1n0-3"
})(["display:flex;width:100%;& ", " + ", "{margin-left:6px;}"], ButtonStyled, ButtonStyled);

var OrderControls = function OrderControls(_ref4) {
  var isMobileControlsVisible = _ref4.isMobileControlsVisible,
      toggleMobileControls = _ref4.toggleMobileControls,
      onAddToOrder = _ref4.onAddToOrder,
      onAddToCart = _ref4.onAddToCart,
      isKomus = _ref4.isKomus,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? EnumButtonSize.normal : _ref4$size;
  var controlsRef = useRef(null);
  var iconFillColor = isKomus ? '#DA1F2A' : '#004B46';
  useEffect(function () {
    function handleClickOutside(event) {
      var target = event.target;

      if (controlsRef.current && !controlsRef.current.contains(target)) {
        toggleMobileControls(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [controlsRef, toggleMobileControls]);
  return isMobileControlsVisible ? React.createElement(OrderControlsWrapper, {
    ref: controlsRef
  }, onAddToOrder && React.createElement(OrderButton, {
    size: size,
    onClick: function onClick() {
      onAddToOrder();
      toggleMobileControls(false);
    },
    isKomus: isKomus
  }, "\u0412 \u0437\u0430\u043A\u0430\u0437"), onAddToCart && React.createElement(ButtonStyled, {
    "data-testid": PRODUCT_ADD_BUTTON_TEST_ID,
    size: size,
    icon: true,
    onClick: onAddToCart,
    isKomus: isKomus
  }, isKomus ? React.createElement(Cart, {
    color: colors.primaryMain
  }) : React.createElement(Cart, null))) : React.createElement(MobileButton, {
    isKomus: isKomus,
    "data-testid": PRODUCT_ADD_BUTTON_TEST_ID,
    size: size,
    icon: true,
    onClick: function onClick() {
      toggleMobileControls(true);
    }
  }, React.createElement(Icon, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: iconFillColor
  }, React.createElement("rect", {
    x: "2",
    y: "7",
    width: "12",
    height: "2",
    rx: "1"
  }), React.createElement("rect", {
    x: "9",
    y: "2",
    width: "12",
    height: "2",
    rx: "1",
    transform: "rotate(90 9 2)"
  })));
};

export default OrderControls;